module.exports = __webpack_public_path__ + "static/media/9ddb6c7c.jpg";